import { Map, Record } from 'immutable';

const struct = {
  id:           undefined,
  title:        undefined,
  brief:        undefined,
  description:  undefined,
  salary:       '',
  salaryType:   '',
  currencyType: '',
  jobType:      '',
  remoteType:   undefined,
  createdAt:    undefined,
  updatedAt:    undefined,
  deletedAt:    undefined,
  address:      new Map(),

  templateCampaignId: undefined,
};

export default class JobRecord extends Record(struct, 'JobRecord') {
  salaryDetails() {

    if(!this.salary || this.salary.trim().length === 0) return t('eos.landing_page.label.undisclosed');

    const details = [this.salary, this.currencyType];

    if (this.salaryType) {
      const freq = t(this.salaryType, { scope: 'eos.landing_page.text.salary_types', defaultValue: this.salaryType });
      details.push(`/ ${freq}`);
    }

    return details.filter((i) => i).join(' ');
  }

  isTemplate() {
    return this.templateCampaignId !== undefined;
  }
}
